import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RunningWithErrorsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"running_with_errors"}/>
}
